<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  padding: 0px;
  margin: 0px;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
